import React, { useState } from 'react';
import './style.scss';
import PrimaryInput from '../inputs/primaryInput';
import logoWithTm from '../../assets/images/svgs/flexgradetm.svg'
import { InstagramIcon, Linkedin } from '../../assets/icons/Icons';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { sendContactEmail } from '../../api/apis/email';

const Footer = ({ onlyFooter }) => {

    const [loading, setLoading] = useState(false);
    const [contactData, setContactData] = useState({
        firstName: "",
        lastName: "",
        businessEmail: "",
        message: "",
    })

    const socialLinks = [
        {
            title: "info@flexgrade.io",
            link: "mailto:info@flexgrade.io"
        },
        {
            title: <InstagramIcon />,
            link: "https://www.instagram.com/flexgrade/",
            newTab: true
        },
        {
            title: <Linkedin />,
            link: "https://www.linkedin.com/company/flexgrade/?viewAsMember=true",
            newTab: true
        },
        {
            title: "Blog",
            link: "https://flexgrade.substack.com/?r=5e5tqp&utm_campaign=pub-share-checklist",
            newTab: true
        },
    ]

    const btnDisabled = !contactData?.firstName || !contactData?.lastName || !contactData?.businessEmail || !contactData?.message;

    const handleChange = (e) => {
        const { name, value } = e?.target ?? {};
        setContactData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const clearForm = () => {
        setContactData({
            firstName: "",
            lastName: "",
            businessEmail: "",
            message: "",
        })
    }

    const handleSave = async () => {
        try {
            setLoading(true)
            const response = await sendContactEmail(contactData);
            if (response?.data?.success) {
                clearForm();
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    return (
        <div className='footer__main'>
            {!onlyFooter ? <div className='form__section'>
                <div className='custom__container d-flex justify-content-between flex-wrap row-gap-4'>
                    <div className='text__section'>
                        <h3>
                            Connect with Us
                        </h3>
                        <div className='heading__border' />
                        <p>
                            Let us define the evolution of the industry together - we'd love to hear from you!
                        </p>
                    </div>
                    <div className='form__container'>
                        <div className='inputs'>
                            <PrimaryInput onChange={handleChange} name={"firstName"} value={contactData?.firstName} label={"First Name *"} placeholder={"First Name"} halfWidth />
                            <PrimaryInput onChange={handleChange} name={"lastName"} value={contactData?.lastName} label={"Last Name *"} placeholder={"Last Name"} halfWidth />
                            <PrimaryInput onChange={handleChange} name={"businessEmail"} value={contactData?.businessEmail} label={"Business Email *"} placeholder={"example@email.com"} />
                            <PrimaryInput onChange={handleChange} name={"message"} value={contactData?.message} textarea label={"Message (optional) "} placeholder={"Enter message here..."} />
                            <button disabled={btnDisabled} onClick={handleSave} >
                                {loading ? <Spinner animation="border" role="status"></Spinner> : 'Let’s Connect'}
                            </button>
                        </div>
                    </div>
                </div>
            </div> : ""}
            <div className={`${onlyFooter ? 'border__top' : ""} links__section custom__container d-flex justify-content-between align-items-center`}>
                <div className='left__section d-flex'>
                    <div>
                        <img src={logoWithTm} alt='login' />
                    </div>
                    {window.innerWidth > 525 ? socialLinks?.map((v, i) => {
                        return <div key={i}>
                            <Link target={v?.newTab ? "_blank" : ""} to={v?.link}>
                                {v?.title}
                            </Link>
                        </div>
                    }) : socialLinks?.reverse()?.map((v, i) => {
                        return <div key={i}>
                            <Link target={v?.newTab ? "_blank" : ""} to={v?.link}>
                                {v?.title}
                            </Link>
                        </div>
                    })}
                </div>
                <div className='right__section'>
                    <Link to={"/website-terms"} target='_blank' >
                        Website Terms
                    </Link>
                    <Link to={"/cookie-policy"} target='_blank' >
                    Cookie Policy
                    </Link>
                    <Link to={"/privacy-policy"} target='_blank' >
                        Privacy Policy
                    </Link>
                    <Link to={"/operator-terms"} target='_blank' >
                    Operator Terms
                    </Link>
                </div>
            </div>
            <div className='backgrounds__border'>
                <div className='light__blue' />
                <div className='blur__blue' />
                <div className='black' />
            </div>
        </div>
    )
}

export default Footer
